"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _constants = require("../../constants");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var orientationCSS = function orientationCSS(props) {
  var orientation = props.orientation,
    percentComplete = props.percentComplete,
    size = props.size;
  return (0, _styledToken.default)({
    size: "ProgressMeter.sizes." + size,
    transition: 'ProgressMeter.transition'
  }, function (tokens) {
    return (0, _styledComponents.css)(["height:", ";width:", ";&::before{", ":", "%;", ":", "px;transition:", " ", ";}"], orientation === _constants.ORIENTATIONS.vertical ? '100%' : 'auto', orientation === _constants.ORIENTATIONS.vertical ? tokens.size + "px" : 'auto', orientation === _constants.ORIENTATIONS.vertical ? 'height' : 'width', percentComplete, orientation === _constants.ORIENTATIONS.vertical ? 'width' : 'height', tokens.size, orientation === _constants.ORIENTATIONS.vertical ? 'height' : 'width', tokens.transition);
  })(props);
};

/** @class ProgressBarMixin */
/** @method */
var ProgressBarMixin = function ProgressBarMixin(props) {
  var size = props.size,
    percentComplete = props.percentComplete;
  return (0, _styledToken.default)({
    borderRadius: 'ProgressMeter.borderRadius',
    backgroundColor: 'ProgressMeter.backgroundColor',
    colorCompleted: 'ProgressMeter.indicatorColorCompleted',
    colorInProgress: 'ProgressMeter.indicatorColorInProgress',
    size: "ProgressMeter.sizes." + size
  }, {
    defaultValue: ''
  }, function (tokens) {
    return (0, _styledComponents.css)(["border-radius:", "px;background-color:", ";&::before{border-radius:", "px;content:'';display:block;background-color:", ";}", ""], tokens.borderRadius, tokens.backgroundColor, tokens.borderRadius, percentComplete >= 100 ? tokens.colorCompleted : tokens.colorInProgress, (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('orientation', orientationCSS)(props));
  })(props);
};
exports.ProgressBarMixin = ProgressBarMixin;